import { ExtendableError } from '@edgvr-front/util/common';

export class ValidationError extends ExtendableError {
  constructor(message: string, cause?: Error) {
    super(message, cause);
  }
}
